import React from 'react';
import { useFeatureAppConfig } from '../../services/use-feature-app-config';
import { atom, useRecoilState } from 'recoil';
import DealerReviews from '../../page/dealer-reviews';
import { fetchDealerData } from '../../fetch-data/fetch-dealer-data';
import { useFeatureServices } from '../../services/use-feature-services';
import { fetchReviewsDataVersion } from '../../fetch-data/fetch-data-version';
import { Spinner } from '@vw-marketing/us-components';
import { DealerReview } from '../../typings/dealer-review';
import AllDealerReviews from '../../page/dealer-reviews/all-dealer-reviews';
import { useTrackingManager } from '../../services/use-tracking-manager';
import _ from 'lodash';

export const dealerData = atom({
  key: 'dealerState',
  default: {} as DealerReview,
});
export const dataVersion = atom({
  key: 'dataVersion',
  default: '',
});
const DealerReviewLoader = () => {
  const { dealerConfiguration, apiKeyContent, mode } = useFeatureAppConfig();
  const trackingManager = useTrackingManager();
  const [isOpenModal, setIsOpenModal] = React.useState(false);
  const [appState, setAppState] = React.useState('loading');
  const [dealer, setDealer] = useRecoilState(dealerData);
  const setDataVersion = useRecoilState(dataVersion)[1];

  const { 'service-config-provider': serviceProvider } = useFeatureServices();
  const reviewsHostData = serviceProvider.configs['fiveStars'];
  const isDealerNameMode =  mode?.includes("name");

  const getDealerData = async () => {
    if (!dealerConfiguration || !dealerConfiguration.dealerid)
      throw Error('No dealer configured');
    if (dealer?.dealer_id?.includes(dealerConfiguration.dealerid)) return;
    const { dealerid: dealerId } = dealerConfiguration;
    const currentDataVersion = await fetchReviewsDataVersion({
      reviewsHostData,
      apiKeyContent,
    });
    const dealerReviews = await fetchDealerData({
      reviewsHostData,
      apiKeyContent,
      dataVersion: currentDataVersion,
      dealerId,
    });
    setDealer(dealerReviews);
    setDataVersion(currentDataVersion);
  };
  const onCloseModalHandler = () => {
    setIsOpenModal(false);
  };
  const onOpenModalHandler = () => {
    setIsOpenModal(true);
  };
  React.useEffect(() => {
    getDealerData()
      .then(() => {
        setAppState('loaded');
      })
      .catch(error => {
        console.log(error);
        setAppState('error');
      });
  }, []);

  if (appState === 'loading') return <Spinner />;
  if ((appState === 'error' || !dealer) && !isDealerNameMode) return <div className="no-dealer-reviews"></div>;
  return (
    <>
      <DealerReviews
        reviews={dealer as DealerReview}
        onOpenReviews={onOpenModalHandler}
        isDealerName={isDealerNameMode}
        dealerName={dealerConfiguration?.name}
      />
      {isOpenModal && <AllDealerReviews
        reviews={dealer as DealerReview}
        trackingManager={trackingManager}
        active={isOpenModal}
        onCloseHandler={onCloseModalHandler}
        hasReviews={!_.isEmpty(dealer)}
      />}
    </>
  );
};

export default DealerReviewLoader;
